import {
  HELP_SEND_REQUEST,
  HELP_SEND_SUCCESS,
  HELP_SEND_FAIL,
  HELP_CLEAR_STATUS,
  GUEST_HELP_SEND_REQUEST,
  GUEST_HELP_SEND_SUCCESS,
  GUEST_HELP_SEND_FAIL,
  GUEST_HELP_CLEAR_STATUS,
} from '../actions/help';

const initialState = {
  // Authenticated Help
  loading: false,
  success: false,
  error: null,

  // Guest Contact Us
  guestLoading: false,
  guestSuccess: false,
  guestError: null,
};

export default function helpReducer(state = initialState, action) {
  switch (action.type) {
    // Authenticated help flow
    case HELP_SEND_REQUEST:
      return { ...state, loading: true, success: false, error: null };

    case HELP_SEND_SUCCESS:
      return { ...state, loading: false, success: true, error: null };

    case HELP_SEND_FAIL:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
      };

    case HELP_CLEAR_STATUS:
      return { ...state, loading: false, success: false, error: null };

    // Guest contact us flow
    case GUEST_HELP_SEND_REQUEST:
      return {
        ...state,
        guestLoading: true,
        guestSuccess: false,
        guestError: null,
      };

    case GUEST_HELP_SEND_SUCCESS:
      return {
        ...state,
        guestLoading: false,
        guestSuccess: true,
        guestError: null,
      };

    case GUEST_HELP_SEND_FAIL:
      return {
        ...state,
        guestLoading: false,
        guestSuccess: false,
        guestError: action.payload,
      };

    case GUEST_HELP_CLEAR_STATUS:
      return {
        ...state,
        guestLoading: false,
        guestSuccess: false,
        guestError: null,
      };

    default:
      return state;
  }
}
